import { useMutation } from "@tanstack/react-query";
import api from "../../services/api";

interface CustomerLoginResponse {
  token: string;
  coreIndustry: string;
}

interface CustomerLoginParams {
  cd_cliente: number;
}

export const useCustomerLogin = () => {
  return useMutation<CustomerLoginResponse, Error, CustomerLoginParams>({
    mutationFn: async ({ cd_cliente }) => {
      const response = await api.post<CustomerLoginResponse>(
        `cliente/${cd_cliente}/login`
      );
      return response.data;
    },
    onSuccess: data => {
      const { token, coreIndustry } = data;
      window.location.href = `/login/${token}/1/${coreIndustry}`;
    },
  });
};
